export enum UserStatus {
  Opened,
  Confirmed,
  Declined,
}

export enum OperationMode {
  Create,
  Edit,
}

export enum UserType {
  User,
  Manager,
  Administrator,
}

export enum MapModeType {
  SingleMarker,
  AllMarkers,
}

export enum ExcelTemplateType {
  EnergyTemplate = 0,
  RabaTemplate = 1,
}

export enum BuildingManagementType {
  NoManagement,
  SingleManagement,
  GroupOfOwners,
}

export enum BuildingsActionType {
  Import = 0,
  Export = 1,
}

export enum ManageBuildingTypes {
  Add = 0,
  Update,
  Details,
  Preview,
}

export enum LanguageType {
  MK = 1,
  EN = 2,
}

export enum BuildingCategories {
  // Energy
  BasicInfo,
  CO,
  CO2,
  Consumation,
  Dust,
  Energy,
  Geometry,
  Investment,
  MoneySaving,
  NMVOC,
  Nox,
  PricePerInvestment,
  Profitability,
  SO2,
  BuildingYearlyTermalEnergySaving,

  // Raba
  RabaBasic,
  RabaManagement,
  RabaGeometry,
  RabaFunctionality,
  RabaArchitecture,
  RabaOtherInfo,
}
